import AddressesRequest from '@/shared/infrastructure/addresses/Request'
import AccountRequest from '@/shared/infrastructure/account/Request'
import OrderRequests from '@/shared/infrastructure/orders/Request'

const actions = {
  fetchBuyerAddresses() {
    return AddressesRequest.fetchBuyerAddresses()
  },
  addBuyerAddress(actions, address) {
    return AddressesRequest.addBuyerAddress(address)
  },
  updateBuyerAddress(action, address) {
    return AddressesRequest.updateBuyerAddress(address)
  },
  deleteBuyerAddress(action, id) {
    return AddressesRequest.deleteBuyerAddress(id)
  },
  fetchBuyerAccount() {
    return AccountRequest.fetchBuyerAccount()
  },
  updateBuyerAccount(action, formData) {
    return AccountRequest.updateBuyerAccount(formData)
  },
  fetchBuyerOrders(action, filters) {
    return OrderRequests.fetchBuyerOrders(filters)
  },
  fetchDraftOrders(action, payload) {
    return OrderRequests.fetchDraftOrdersRequest(payload)
  },
  deleteDraftOrders(action, payload) {
    return OrderRequests.deleteDraftOrdersRequest(payload)
  },
  deleteAllDrafts(){
    return OrderRequests.deleteAllDrafts()
  },
  changeTotalDraftsCount({ commit }, payload) {
    commit('setTotalDraftsCount', payload)
  }
}

export default actions
